import HelpTemplate from "components/templates/HelpTemplate/HelpTemplate";

export default function HelpPage() {
  return <HelpTemplate />;
}
